// extracted by mini-css-extract-plugin
export var carrierTab = "_4u-0";
export var carrierTabActive = "_4u-1 _4u-0";
export var carrierTabInactive = "_4u-2 _4u-0";
export var carrierTabLabel = "_4u-3";
export var carrierTabLabelActive = "_4u-4 _4u-3";
export var carrierTabLabelInactive = "_4u-5 _4u-3";
export var carrierTabPercentage = "_4u-6";
export var carrierTabPercentageActive = "_4u-7 _4u-6";
export var carrierTabPercentageInactive = "_4u-8 _4u-6";
export var carrierTabWinnable = "_4u-9";
export var carrierTabWinnableActive = "_4u-a _4u-9";
export var carrierTabWinnableInactive = "_4u-b _4u-9";
export var comparisonContainer = "_4u-d";
export var missingRateButton = "_4u-n";
export var missingRateButtonActive = "_4u-o _4u-n";
export var missingRateButtonInactive = "_4u-p _4u-n";
export var missingRateButtonLabel = "_4u-q";
export var missingRateButtonLabelActive = "_4u-r _4u-q";
export var missingRateButtonLabelInactive = "_4u-s _4u-q";
export var sidebar = "_4u-c";
export var strategyButton = "_4u-e";
export var strategyButtonActive = "_4u-f _4u-e";
export var strategyButtonDescription = "_4u-k";
export var strategyButtonDescriptionActive = "_4u-l _4u-k";
export var strategyButtonDescriptionInactive = "_4u-m _4u-k";
export var strategyButtonInactive = "_4u-g _4u-e";
export var strategyButtonLabel = "_4u-h";
export var strategyButtonLabelActive = "_4u-i _4u-h";
export var strategyButtonLabelInactive = "_4u-j _4u-h";
export var unitToggleButton = "_4u-t";
export var unitToggleButtonActive = "_4u-u _4u-t";
export var unitToggleButtonInactive = "_4u-v _4u-t";
export var unitToggleButtonLabel = "_4u-w";
export var unitToggleButtonLabelActive = "_4u-x _4u-w";
export var unitToggleButtonLabelInactive = "_4u-y _4u-w";